module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLT-Medium.62b0a74b.woff";